import { Suspense, lazy } from 'react';

const FolderDetails = lazy(() => import('../components/Folders/FolderDetails'));

const FolderDetailsLazy: React.FC = () => {
    return <Suspense><FolderDetails/></Suspense>;
}

export default FolderDetailsLazy;